export default __webpack_public_path__ + "static/media/logo-light.5a9a2083.png";